<template>
  <div id="detail-actions">
    <div class="border-bottom mar-b-4"
         v-if="!['WITHDRAWN','PAPER_ACCEPTED','REJECTED','ONLINE'].includes(data.status)&&user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.EDIT_MANUSCRIPT')">
      <ipub-tooltip placement="left"
                    class="mar-b-4 ">
        <div slot="title">
          Edit Manuscript
        </div>
        <ipub-icon @click="editManuscript()"
                   type="iconEdit" />
      </ipub-tooltip>
    </div>
    <div class="border-bottom mar-b-4">
      <ipub-tooltip placement="left"
                    class="mar-b-4 ">
        <div slot="title">
          Manuscript Note
        </div>
        <ipub-icon @click="manuscriptNote('remark')"
                   type="icona-ManuscriptNote" />
      </ipub-tooltip>
    </div>
    <!-- <div class="border-bottom mar-b-4">
      <ipub-tooltip placement="left"
                    class="mar-b-4 ">
        <div slot="title">
          Special Issue Note
        </div>
        <ipub-icon @click="manuscriptNote('specialRemark')"
                   type="icona-SpecialIssueNote" />
      </ipub-tooltip>
    </div> -->
    <!-- <div v-if="['PENDING_MINOR_REVISIONS', 'PENDING_MAJOR_REVISIONS'].includes(data.status)&&user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.EDIT_REVISION_DUE_DATE')"
         class="border-bottom mar-b-4">
      <ipub-tooltip placement="left"
                    class="mar-b-4 ">
        <div slot="title">
          Update Revision Due Date
        </div>
        <ipub-icon @click="editDate()"
                   type="iconCalendar" />
      </ipub-tooltip>
    </div> -->
    <!-- <div v-if="['SUBMITTED', 'PENDING_APC_CONFIRM'].includes(data.status)&&user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.BACK_TO_AUTHOR')"
         class="border-bottom mar-b-4">
      <ipub-tooltip placement="left"
                    class="mar-b-4 ">
        <div slot="title">
          Back to Author
        </div>
        <ipub-icon @click="subEmail('backToAuthor')"
                   type="icona-BacktoAuthor" />
      </ipub-tooltip>
    </div> -->
    <div class="border-bottom mar-b-4"
         v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.CORRESPONDENCE_RECORD')">
      <ipub-tooltip placement="left"
                    class="mar-b-4 ">
        <div slot="title">
          Correspondence Record
        </div>
        <ipub-icon @click="corespondenceRecord()"
                   type="icona-CorrespondenceHistory" />
      </ipub-tooltip>
    </div>
    <div class="border-bottom mar-b-4"
         v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.FILE_HISTORY')">
      <ipub-tooltip placement="left">
        <div slot="title">
          Files
        </div>
        <ipub-icon type="iconVersion"
                   @click="viewFiles()" />
      </ipub-tooltip>
    </div>
    <div class="border-bottom mar-b-4"
         v-if="['PAPER_ACCEPTED', 'PENDING_PRE_CHECK', 'PRE_CHECK_DONE', 'PENDING_MINOR_REVISIONS', 'PENDING_MAJOR_REVISIONS'].includes(data.status)&&user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.WITHDRAW')">
      <ipub-tooltip placement="left">
        <div slot="title">
          Withdraw
        </div>
        <!-- <ipub-icon @click="withdraw()"
                 type="iconReject" /> -->
        <ipub-icon @click="subEmail('widthdraw')"
                   type="iconReject" />
      </ipub-tooltip>
    </div>
    <div class="border-bottom mar-b-4"
         v-if="!['PENDING_RESUBMISSION', 'PENDING_MINOR_REVISIONS', 'PENDING_MAJOR_REVISIONS', 'PAPER_ACCEPTED', 'REJECTED', 'WITHDRAWN','ONLINE'].includes(data.status) && data.signList[0]===data.sign&&user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.DECISION_TO_AUTHOR')">
      <ipub-tooltip placement="left">
        <div slot="title">
          {{data.status === 'PENDING_DECISION' ?'Final Decision':'Decision to Author'}}
        </div>
        <ipub-icon @click.stop="Decision(data.status)"
                   type="icona-SpecialIssueEdit" />
      </ipub-tooltip>
    </div>
    <div class="border-bottom mar-b-4"
         v-if="['PAPER_ACCEPTED','ONLINE'].includes(data.status)&&(!data.mauthorList.some(item=>item.sanctioned))&&user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.GENERATE_INVOICE')">
      <ipub-tooltip placement="left">
        <div slot="title">
          Invoice
        </div>
        <ipub-icon type="iconinvoice"
                   @click="createCanvans(data, 'Invoice')" />
      </ipub-tooltip>
    </div>
    <!-- <div>
      <ipub-tooltip v-show="user.codeList && user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.SET_ACADEMIC_EDITOR_VISIBILITY')"
                    placement="bottomRight"
                    class="border-right">
        <div slot="title">
          <font v-if="data.locked===true">Academic Editor can see this manuscript details</font>
          <font v-else>Academic Editor can not see this manuscript details</font>
        </div>
        <ipub-icon v-if="data.locked===true"
                   @click="lock(data)"
                   type="iconLock_Close" />
        <ipub-icon v-else
                   @click="lock(data)"
                   type="iconLock_Open" />
      </ipub-tooltip>
    </div> -->

    <div class="ipub-line-block ipub-border"
         v-show="type && noteVisable"
         style="width: 282px;">
      <div class="ipub-h5 mar-b-10 relative">
        {{type==='remark'?'Manuscript Note': 'Special Issue Note'}}
        <div class="right-option">
          <ipub-icon @click="manuscriptNote()"
                     type="iconClose" />
        </div>
      </div>
      <ipub-textarea class="mar-b-10"
                     :autoSize="{ cols: '', rows: '10' }"
                     v-model="remark" />

      <ipub-button v-show="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.SAVE_NOTE')"
                   type="primary"
                   plain
                   size="small"
                   style="width: 80px;"
                   class="ipub-p1"
                   @click="save">Save</ipub-button>
    </div>
    <EditDate :isVisable="showEditDate"
              :inputData="inputData"
              @confirm="confirm"
              @cancel="cancel" />
    <reviewReport :isVisable="showReviewReport"
                  :inputData="inputData"
                  @confirm="decisionConfirm"
                  @cancel="cancel" />
    <CreatePDF :isVisable="isVisablePDF"
               :inputData="inputData"
               :type="pdfType"
               @confirm="cancel"
               @save="cancel"
               @sendEm="emailPdf"
               @cancel="cancel" />
    <files-history :inputData="inputData"
                   :isVisable="allFilesVisiable"
                   @cancel="cancel"></files-history>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { editorManuscript, editor } from '@/api/editor'
import EditDate from './edit-date.dialog'
import reviewReport from '../dialog/review-report'
import CreatePDF from './createPDF.dialog'
import filesHistory from './files-history.vue'
import manuscript from '@/api/manuscript'


export default {
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    ReviewHistoryScrollTop: {
      type: Number,
      default: 0
    }
  },
  components: {
    EditDate,
    reviewReport,
    CreatePDF,
    filesHistory
  },
  data () {
    return {
      isShow: false,
      type: '',
      remark: '',
      inputData: {},
      showEditDate: false,
      showReviewReport: false,
      pdfType: 'Invoice',
      isVisablePDF: false,
      allFilesVisiable: false,
      noteVisable: true,
      beforScrollTop: 0
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  mounted () {

    this.startScroll()
  },
  beforeDestroy () {
    this.removeScroll()
  },
  methods: {
    // 开始监听
    startScroll () {
      window.addEventListener(
        'scroll',
        this.handleScroll,
        true
      )
    },
    removeScroll () {
      window.removeEventListener('scroll', this.handleScroll, true)
    },
    handleScroll () {
      // flag = true 显示弹窗  type= 'remark'   scrollTop < 420 显示  scrollTop == 0 有弹窗 不显示  无弹窗 显示
      if (document.documentElement.scrollTop && document.documentElement.scrollTop > 420) {
        this.type = ''
      } else {
        this.type = 'remark'
        this.remark = this.data['remark']
      }
    },
    editManuscript () {
      this.$router.push(`/editorial-office/manuscripts/submit-manuscripts/step1?id=${this.data.id}`)
    },
    manuscriptNote (val) {
      this.type = val
      this.remark = this.data[val]
    },
    inviteReviewer () {
      setTimeout(() => {
        document.documentElement.scrollTop = document.body.scrollTop =
          this.ReviewHistoryScrollTop
      }, 500)
    },
    submitDecision () {
      this.$router.push(
        `/editorial-office/manuscripts/decisions-editorial?sign=${this.data.sign}&manuscriptId=${this.data.id}`
      )
    },
    editDate () {
      this.showEditDate = true
      this.inputData = this.data
      this.removeScroll()
    },
    async backToAuthor () {
      this.$emit('sendEmail', 'BACK_TO_AUTHOR')
      const { id, version, sign } = this.data
      await editor.dismiss(id, {
        version,
        sign
      })
      this.$message.success({
        title: 'Success',
        content: `This Manuscript has been backed to author!`
      })
      this.$emit('confirm')
    },
    finalDecision () {
      this.$router.push(
        '/editorial-office/manuscripts/decisions-final?sign=' +
        this.data.sign +
        '&manuscriptId=' +
        this.data.id
      )
    },
    reviewResult () {
      this.$router.push('/editorial-office/manuscripts/details/review-history/' + this.data.id)
    },
    corespondenceRecord () {
      this.$router.push(
        '/editorial-office/manuscripts/corespondence-record/' + this.data.id
      )
    },
    async withdraw () {
      this.$emit('sendEmail', 'WITHDRAW')
      const { id, version, sign } = this.data
      await editor.withdraw(id, {
        version,
        sign
      })
      this.$message.success({
        title: 'Success',
        content: `This Manuscript has been withdraw!`
      })
      this.$emit('confirm')
    },
    Decision (statu) {
      this.inputData = {
        id: this.data.id,
        sign: this.data.sign,
        statu: statu
      }
      this.showReviewReport = true
      this.removeScroll()
    },
    decisionConfirm (statu) {
      this.showReviewReport = false
      if (statu === 'PENDING_DECISION') {
        location.href = `/editorial-office/manuscripts/decisions-final?sign=${this.data.sign}&manuscriptId=${this.data.id}`
        return
      }
      location.href = `/editorial-office/manuscripts/decisions-editorial?sign=${this.data.sign}&manuscriptId=${this.data.id}`
    },
    async save () {
      const fun = editorManuscript[this.type]
      const data = {}
      data.sign = this.data.sign
      data.version = this.data.version
      data[this.type] = this.remark
      await fun(this.data.id, data)
      this.$message.success({ title: 'Success', content: `This Remark has been saved!` })
      this.type = ''
      this.$emit('confirm')
    },
    confirm () {
      this.$emit('sendEmail', 'MODIFIED_THE_REVISION_TIME')
      this.$emit('confirm')
      this.showEditDate = false
      this.startScroll()
    },
    cancel () {
      this.showEditDate = false
      this.showReviewReport = false
      this.isVisablePDF = false
      this.allFilesVisiable = false
      this.startScroll()
    },
    async subEmail (type) {
      this.removeScroll()
      if (type === 'backToAuthor') {
        this.$emit('sendEmail', 'BACK_TO_AUTHOR', 'backToAuthor')
      }
      else if (type === 'widthdraw') {
        this.$emit('sendEmail', 'WITHDRAW', 'widthdraw')
      }
    },
    // 邮件发送调用 backToAuthor
    async backToAuthorCall () {
      const { id, version, sign } = this.data
      await editor.dismiss(id, {
        version,
        sign
      })
      this.$message.success({
        title: 'Success',
        content: `This Manuscript has been backed to author!`
      })
      this.$emit('confirm')
    },
    // 邮件发送后调用 withdraw
    async widthdrawCall () {
      const { id, version, sign } = this.data
      await editor.withdraw(id, {
        version,
        sign
      })
      this.$message.success({
        title: 'Success',
        content: `This Manuscript has been withdraw!`
      })
      this.$emit('confirm')
    },
    createCanvans (val, type) {
      if (!val.invoiced) {
        this.inputData = val
        this.pdfType = type
        this.isVisablePDF = true
        this.removeScroll()
      } else {
        this.$message.error({
          title: 'Error',
          content:
            'Please contact our billing colleague at (invoice@imrpress.com) to creat the invoice manually for this manuscript. '
        })
      }
    },
    emailPdf () {
      this.isVisablePDF = false
      this.$emit('sendEmail', 'SEND_APC_INVOICE_TO_AUTHOR', 'invoice_to_author')
      this.startScroll()
    },
    viewFiles () {
      this.inputData = {
        id: this.data.id
      }
      this.allFilesVisiable = true
      this.removeScroll()
    },
    async lock (record) {
      let content = ``
      if (record.locked === true) {
        content = `Now Academic Editor can see this manuscript details!`
      } else {
        content = `Now Academic Editor can not see this manuscript details!`
      }
      await manuscript.locked(record.id, !record.locked)
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
#detail-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: -1px -1px 10px 0px rgba(206, 232, 234, 0.5);
  width: 50px;
  padding: 12px 0;
  font-size: 24px;
  position: fixed;
  right: 0;
  top: 180px;
  background: $content_color;
  border-radius: 4px;
  z-index: 999;
  cursor: pointer;
  // @include mq($xl) {
  //   // right: calc(50vw - 800px);
  //   right: 0;
  // }
  .ipub-p5 {
    font-size: 10px;
  }
  &.isShow {
    opacity: 1 !important;
  }

  .ipub-line-block {
    position: fixed;
    top: 180px;
    right: 70px;
    padding: 16px 24px;
    // @include mq($xl) {
    //   right: calc(50vw - 730px);
    // }
  }
}
</style>
